module.exports = __webpack_public_path__ + "img/icon-stockpicker-generating-done@3x.80afe1c5.png";